import React from 'react';

/* Props: 
productCategories= Takes Product Categories as an Array
*/
const DokanTableItemShortCategories = ({ productCategories }) => (
    <span className="text-xs text-violet">
        {productCategories.map((cat, index) => (
            <span key={cat.id}>
                {cat.name}
                {index < productCategories.length - 1 ? ', ' : ''}
            </span>
        ))}
    </span>
);

export default DokanTableItemShortCategories;
